import { useAppearance } from '@/lib/design/appearance';
import { getDesignTokens } from '@/lib/design/theme';
import * as React from 'react';
import { StyleSheet, View } from 'react-native';

export function PublicWebPanel({
  children,
  tone = 'default',
}: {
  children: React.ReactNode;
  tone?: 'default' | 'accent';
}) {
  const resolvedMode = useAppearance((state) => state.resolvedMode);
  const tokens = React.useMemo(() => getDesignTokens(resolvedMode), [resolvedMode]);
  const styles = React.useMemo(() => createStyles(tokens), [tokens]);

  return <View style={tone === 'accent' ? styles.accentPanel : styles.panel}>{children}</View>;
}

function createStyles(tokens: ReturnType<typeof getDesignTokens>) {
  return StyleSheet.create({
    panel: {
      backgroundColor: tokens.colors.surface,
      borderColor: tokens.colors.border,
      borderRadius: 26,
      borderWidth: 1,
      flexGrow: 1,
      flexShrink: 1,
      gap: 10,
      minWidth: 250,
      padding: 22,
    },
    accentPanel: {
      backgroundColor: tokens.colors.accentSoft,
      borderColor: tokens.colors.accentEdge,
      borderRadius: 26,
      borderWidth: 1,
      flexGrow: 1,
      flexShrink: 1,
      gap: 10,
      minWidth: 250,
      padding: 22,
    },
  });
}
